import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-discount',
  templateUrl: './edit-discount.component.html',
  styleUrls: ['./edit-discount.component.scss']
})
export class EditDiscountComponent implements OnInit {
  discountData={
    name:'',
    discount_type:'',
    amount:'',
    notes:'',
    admin_notes:''
  }
  discountId:any
  constructor( private activatedroute:ActivatedRoute,
    public toastr: ToastrService,
    public apiService:ApiService,
    private route:Router) { 
      this.activatedroute.paramMap.subscribe(params => { 
        this.discountId = params.get('id'); 
        console.log('tag idd',this.discountId)
    });
  }

  ngOnInit(): void {
    this.getDiscountById()
  }
  getDiscountById(){
    this.apiService.getDiscountById(this.discountId).subscribe((res:any)=>{
      console.log('dis res=>',res)
      this.discountData=res.data
    })
  }
  discountUpdate(){
   if(this.discountId){
    this.apiService.updateDiscount(this.discountId,this.discountData).subscribe((res:any)=>{
      if(res.isSuccess ===true){
        console.log('update res',res)
        this.toastr.success('Updated successfully!')
        this.route.navigate(['/discounts/discount-list'])
      }
      else{
        this.toastr.error(res.error);
      }      
    })
   }
   else{
    this.toastr.error('something went wrong!!')
   }
  }
  back(){
    this.route.navigate(['/discounts/discount-list'])

  }

}
